export default __webpack_public_path__ + "static/media/hadiah.9a2d2fc7.png";